import { UserRight } from "../services/WebApiClient";

export default class User {
    constructor(
        public readonly id: string,
        public readonly username: string,
        public readonly name: string,
        public readonly userRights: UserRight[],
    ) {

    }
}
